import { CommonModule } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DropOffDataTable } from '@vectronic/util';
import moment from 'moment';

@Component({
  selector: 'table-datatable-drop-off',
  templateUrl: './datatable-drop-off.component.html',
  styleUrls: ['./datatable-drop-off.component.scss'],
  imports: [
    CommonModule,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatIconModule,
    MatFormFieldModule,
    MatAutocompleteModule,
  ],
})
export class DatatableDropOffComponent {
  dropOffFormControl = new FormControl('');
  inputSignal = toSignal(this.dropOffFormControl.valueChanges, { initialValue: '' });
  row = input<DropOffDataTable>();
  dropOffIds = input<number[]>();
  isEditing = signal(false);
  filteredOptions = computed(() =>
    this.inputSignal()
      ? this._filter(this.inputSignal(), this.dropOffIds())
      : this.dropOffIds()?.slice(),
  );

  tooltip = computed(() => {
    const row = this.row();
    const dropOffId = row.dropOffId ?? row.dropOff?.idDevice ?? row.dropOffExtended?.id;
    if (!dropOffId) {
      return '';
    }
    const deviceTypeName = row.dropOff?.deviceType?.name ?? row.dropOffExtended?.deviceType?.name;
    return `Drop off id: ${dropOffId}
${deviceTypeName ? `Device Type: ${deviceTypeName}` : 'Device Type: Unknown'}
Radio Control: ${row.radioControl || 'Unknown'}
${
  row.releaseTimeMode === 'absolute'
    ? 'Absolute Release Time:' +
      moment.unix(parseInt(row.absoluteReleaseTime) + 946684800).format('YYYY-MM-DD HH:mm')
    : ''
}
${
  row.releaseTimeMode === 'relative'
    ? 'Relative Release Time: ' + this.convertSeconds(parseInt(row.relativeReleaseTime))
    : ''
}`;
  });

  addDropOffId = output<{ dropOffId: string; row: DropOffDataTable }>();

  private _filter(value: string, dropOffIds: number[]): number[] {
    const filterValue = value.toLowerCase();
    return dropOffIds.filter((option) => option.toString().toLowerCase().includes(filterValue));
  }

  convertSeconds(seconds) {
    const weeks = Math.floor(seconds / (7 * 24 * 60 * 60));
    seconds %= 7 * 24 * 60 * 60;
    const days = Math.floor(seconds / (24 * 60 * 60));
    seconds %= 24 * 60 * 60;
    const hours = Math.floor(seconds / (60 * 60));

    return `${weeks ? weeks + 'w ' : ''} ${days ? days + 'd ' : ''} ${hours ? hours + 'h ' : ''}`;
  }
  onClickEdit() {
    this.isEditing.set(true);
  }

  onClickClose() {
    this.isEditing.set(false);
  }

  onSelected($event: MatAutocompleteSelectedEvent) {
    this.addDropOffId.emit({
      dropOffId: $event.option.value,
      row: this.row(),
    });
  }
}
